import { Link } from '@/lib/router';
import { Wordmark } from '../components/Wordmark';

export function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-surface-0">
      <div className="max-w-md text-center flex flex-col items-center gap-4">
        <Wordmark size="lg" />
        <p className="font-ui text-xs uppercase tracking-[0.08em] text-text-tertiary m-0">
          Error 404
        </p>
        <h1 className="font-prose text-xl font-semibold text-text-primary m-0">
          This page doesn&rsquo;t exist.
        </h1>
        <p className="font-prose text-sm text-text-secondary m-0">
          The address may be outdated, or the page may have moved.
        </p>
        <div className="flex items-center gap-3 mt-2">
          <Link
            to="/"
            className="font-ui text-sm px-4 py-2 rounded-md bg-navy-700 text-white no-underline hover:bg-navy-900"
          >
            Go home
          </Link>
          <Link
            to="/docs"
            className="font-ui text-sm px-4 py-2 rounded-md border border-border text-text-secondary no-underline hover:bg-surface-1"
          >
            View docs
          </Link>
        </div>
      </div>
    </main>
  );
}
